import React, { useState, useEffect } from 'react';
import { PHP_BACK } from '../../../../utils/Common';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import axios from 'axios';
import { dateFormatConDiaYHora } from '../../../../utils/DateFunctions';
import vr from '../../../../utils/Verifiers';

const BloquesCargados = (p) => {
  const close = p.change;
  const [loader, setloader] = useState(false);
  const [dialog, setdialog] = useState({ show: false });
  const [history, sethistory] = useState([]);
  useEffect(() => {
    getHistory()
  }, []);

  async function getHistory(p) {
    setloader(true);
    const resp = await vr.getDataAPI('campo/v2/inventario_campo/externo/cargas/historial', {}, setloader, setdialog);
    setloader(false);
    if (!resp.estatus) {
      return;
    }
    sethistory(resp.data);
  }

  const deleteBlock = (id) => {
    setloader(true);
    axios.post(PHP_BACK + 'excel/regs/campo/delete', { id: id })
      .then((data) => {
        getHistory();
        setloader(false);
        p.actualizarFecha();
      })
      .catch(e => { setloader(false); });

  }

  return (
    <div className='col-lg-12 m-0 p-3' style={{ overflow: 'auto' }}>
      <div className='row justify-content-center m-0 p-0'>
        <div className='form-group m-2 contenedor' style={{ width: '150px' }}>
          <button className='btn btn-sm btn-warning shadow' onClick={close}>Cerrar historial</button>
        </div>

        <div className='col-lg-12 mb-2'></div>
        {
          history.map((hist, i) => {
            return (
              <React.Fragment key={`historyExcessl${i}`}>
                <div className='w-100 m-0 p-0'></div>
                <div className='bw-1000 bg-light m-0 mt-3 mb-2 shadow-multi p-2 round-m'>
                  <div className='row justify-content-evenly w-100 m-0 p-0'>
                    <div className='bw-300 mt-2 mb-2 text-center text-bold round-m shadow-sm border border-2'>
                      Cargado: <span className="ms-2 text-400" style={{ color: '#02335F' }}>{dateFormatConDiaYHora(hist.fecha)}</span>
                    </div>
                    <div className='bw-150 mt-2 mb-2 text-center text-bold round-m shadow-sm border border-2'>
                      Registros: <span className="ms-2 text-400" style={{ color: '#02335F' }}>{hist.registros}</span>
                    </div>
                    <div className='bw-200 mt-2 mb-2 text-center text-bold round-m shadow-sm border border-2'>
                      Usuario: <span className="ms-2 text-400" style={{ color: '#02335F' }}>{hist.usuario}</span>
                    </div>
                    {/*<div className='col-auto mt-2 mb-2 '>
                      <button type='button' className='btn btn-sm shadow-sm btn-danger round-m nowrap ps-5 pe-5' onClick={() => {
                        setdialog({
                          show: true,
                          tipo: 'error',
                          title: "CONFIRME",
                          body: '¿Realmente desea eliminar este bloque de registros? Esta acción no es reversible',
                          respNot: 'No, Volver',
                          respYes: "Si eliminar registros",
                          size: 'm',
                          funct: (resp) => { if (resp) { deleteBlock(hist.id) } setdialog({ show: false }) }
                        });
                      }}>Eliminar registros</button>
                    </div>*/}
                  </div>
                </div>
              </React.Fragment>
            )
          })
        }
      </div>
      {loader && <div className='blur-s' style={{ width: '100vw', height: '100vh', position: 'fixed', left: 0, top: 0 }}><div className='loader'></div></div>}
      <VainillaDialog data={dialog} />
    </div>
  )
}

export default BloquesCargados;